/*
 * @Author: zhengshuhua
 * @Date: 2021-09-14 09:24:25
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-01-17 11:02:40
 * @Description: file content
 * @FilePath: \edc-web\src\local\index.js
 */
import deleter from './deleter'
import getter from './getter'
import setter from './setter'
import state from './state'
const locals = { ...deleter, ...getter, ...setter, ...state }
export default locals
